import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6]">
        <div className="font-serif text-2xl text-[#0F292F]/60 italic">Securing session…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/portal/login" replace />;
  return children;
}
